import { render, staticRenderFns } from "./synchronizeSettings.vue?vue&type=template&id=7666b9f6"
import script from "./synchronizeSettings.vue?vue&type=script&lang=js"
export * from "./synchronizeSettings.vue?vue&type=script&lang=js"
import style0 from "./synchronizeSettings.vue?vue&type=style&index=0&id=7666b9f6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports